import React from "react";
import WrapperExpand from "../WrapperExpand";
import { IExpand } from "../../../../types/expand.type";
import { Box, Button, Grid2, Stack, Typography } from "@mui/material";
import { useAlertContext } from "../../../../contexts/alert/AlertProvider";
import { asyncDelete } from "../../../../utils/httpRequests";
import { useSelector } from "react-redux";
import TextInput from "../../input/TextInput";
import { formatDateDisplay, numeralCustom } from "../../../../utils/helpers";
import TableApp from "../../tableapp/TableApp";
import { TableColumn } from "react-data-table-component";

const columns: TableColumn<any>[] = [
  {
    name: "Hàng hóa",
    selector: (row) => `${row.ten_vt} (${row.ma_vt})`,
    cell: (row) => {
      return (
        <Typography>
          {row.ten_vt} ({row.ma_vt})
        </Typography>
      );
    },
    width: "200px",
    wrap: true,
  },
  {
    name: "Số lượng",
    selector: (row) => row.sl_nhap,
    width: "100px",
    wrap: true,
  },
  {
    name: "ĐVT",
    selector: (row) => row.ma_dvt,
    width: "100px",
    wrap: true,
  },
  {
    name: "Giá vốn",
    selector: (row) => row.gia_von_nt,
    format: (row) => numeralCustom(row.gia_von_nt).format(),
    width: "120px",
    wrap: true,
  },
  {
    name: "Tiền nhập",
    selector: (row) => row.tien_nhap_nt,
    format: (row) => numeralCustom(row.tien_nhap_nt).format(),
    width: "120px",
    wrap: true,
  },
];

function ExpandPN1({ data, onOpenEdit, setLoad }: IExpand) {
  const app = useSelector((state: any) => state.app.data);
  const token = useSelector((state: any) => state.auth.token);
  const { showAlert } = useAlertContext();

  const handleDelete = async () => {
    const resp = await asyncDelete({
      apiCode: "pn1",
      id: data?._id,
      token,
      idApp: app?._id,
    });
    if (resp?.status !== 200) {
      showAlert({
        type: "error",
        message:
          resp?.data?.error || resp?.data?.message || "Lỗi khi xóa dữ liệu",
      });
    } else {
      showAlert({ type: "success", message: `Đã xóa thành công` });
      setLoad?.((prev) => prev + 1);
    }
  };

  return (
    <WrapperExpand
      data={data}
      action={
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="center"
          gap={1}
          sx={{ pb: 2 }}
        >
          <Button
            onClick={onOpenEdit}
            variant="contained"
            size="small"
            sx={{
              boxShadow: "none",
              textTransform: "none",
              color: "common.white",
              "&:hover": {
                boxShadow: "none",
              },
            }}
          >
            Chỉnh sửa
          </Button>
          <Button
            onClick={() => {
              showAlert({
                title: "Xác nhận xóa",
                type: "info",
                message: "Bạn có chắc muốn xóa dòng này không ?",
                onConfirm: handleDelete,
              });
            }}
            variant="contained"
            size="small"
            color="error"
            sx={{
              boxShadow: "none",
              textTransform: "none",
              color: "common.white",
              "&:hover": {
                boxShadow: "none",
              },
            }}
          >
            Xóa
          </Button>
        </Stack>
      }
    >
      <Stack gap={2} sx={{ width: "100%", maxWidth: "1000px" }}>
        <Grid2 container spacing={2}>
          <Grid2 size={{ xs: 12, md: 6 }}>
            <Stack gap={2}>
              <TextInput
                readOnly
                labelWidth="25%"
                label="Số CT"
                value={data?.so_ct}
              />
              <TextInput
                readOnly
                labelWidth="25%"
                label="Ngay CT"
                value={formatDateDisplay(data?.ngay_ct, "DD/MM/YYYY HH:mm")}
              />
              <TextInput
                readOnly
                labelWidth="25%"
                label="Chi nhánh"
                value={data?.ten_kho}
              />
              <TextInput
                readOnly
                labelWidth="25%"
                label="Nhà cung cấp"
                value={data?.ten_kh}
              />
            </Stack>
          </Grid2>
          <Grid2 size={{ xs: 12, md: 6 }}>
            <Stack gap={2}>
              <TextInput
                readOnly
                labelWidth="25%"
                label="Tiền hàng"
                value={data?.t_tien_hang}
              />
              <TextInput
                readOnly
                labelWidth="25%"
                label="Tiền phí"
                value={data?.t_cp_nt}
              />
              <TextInput
                readOnly
                labelWidth="25%"
                label="Tiền thuế"
                value={data?.t_thue_vao_nt}
              />
              <TextInput
                readOnly
                labelWidth="25%"
                label="Tiền nhập"
                value={data?.t_tt_nt}
              />
            </Stack>
          </Grid2>
        </Grid2>
        {/* Diễn giải */}
        <Stack
          direction="row"
          alignItems="flex-start"
          spacing="10px"
          sx={{ marginTop: "20px" }}
        >
          <Typography sx={{ fontWeight: 600 }}>Ghi chú:</Typography>
          <Typography>{data.dien_giai}</Typography>
        </Stack>
        {/* Chi tiết */}
        {data?.details?.length > 0 && (
          <Stack sx={{ marginTop: "20px" }}>
            <Typography sx={{ fontWeight: 600 }}>Chi tiết đơn hàng:</Typography>
            <Box
              sx={{
                borderRadius: "10px",
                border: "1px solid",
                borderColor: "divider",
                p: 1,
              }}
            >
              <TableApp columns={columns} data={data.details || []} />
            </Box>
          </Stack>
        )}
      </Stack>
    </WrapperExpand>
  );
}

export default ExpandPN1;
